import { FormItem, Input } from '@vkontakte/vkui';
import PropTypes from 'prop-types';
import { prepareString } from '../../../helpers/helpers';

const NameInputComponent = ({value, setValue, error, setError, label, errorMinLength}) => {
  return (<FormItem
    top={label}
    status={error.length > 0 ? 'error' : ''}
    bottom={error}
  >
    <Input
      value={value}
      maxLength={30}
      minLength={3}
      onChange={(event) => {
        const length = [...prepareString(event.target.value)].length;
        if (length > 2) {
          setError('');
        }

        if (length <= 30) {
          setValue(event.target.value);
        }
      }}
      onBlur={() => {
        setValue(prepareString(value));
        setError([...prepareString(value)].length < 3 ? errorMinLength : '');
      }}
    />
  </FormItem>)
}

export default NameInputComponent;

NameInputComponent.propTypes = {
  value: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
  error: PropTypes.string.isRequired,
  setError: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  errorMinLength: PropTypes.string.isRequired,
};
